import { cn } from "@/lib/utils";

export const CONTROL_HEIGHT = "h-9";
export const CONTROL_RADIUS = "rounded-md";

export const LEARN_ICON_CLASS =
  "animate-tutorial-breathe h-8 w-8 justify-center rounded-md border-transparent px-0 text-primary after:hidden hover:border-transparent hover:bg-white/[0.04] hover:text-primary [&>span]:hidden";

export function controlClass(active?: boolean, className?: string) {
  return cn(
    "inline-flex items-center justify-center gap-1.5 px-3 text-xs font-medium transition-colors whitespace-nowrap",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
    CONTROL_HEIGHT,
    CONTROL_RADIUS,
    active
      ? "border border-primary/30 bg-primary/15 text-primary"
      : "border border-white/[0.08] bg-white/[0.04] text-muted-foreground hover:border-white/15 hover:text-foreground",
    className,
  );
}
